import React from "react";
import DOMPurify from "dompurify";
import Modal from "../Modal/Modal";

const DisruptionsModal = ({
  disruptionsMessages,
  toggleDisruptionsModal,
  isUserWayActive,
  activeModal,
  setActiveModal,
}) => {
  return (
    <Modal
      modalType="disruptionsModal"
      activeModal={activeModal}
      setActiveModal={setActiveModal}
      title="Disruptions"
      close={() => toggleDisruptionsModal(false, null)}
      isUserWayActive={isUserWayActive}
    >
      {Array.isArray(disruptionsMessages) &&
        disruptionsMessages.map((message, index) => (
          <React.Fragment key={index}>
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(message, {
                  ADD_ATTR: ["target"],
                  // sanitize: true, TODO: Re-implement this!
                }),
              }}
            />
            {index < disruptionsMessages.length - 1 && <br />}
          </React.Fragment>
        ))}
    </Modal>
  );
};

export default React.memo(DisruptionsModal);
